<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      <div class="detail-group">
        @if (!hideHeader) {
          <div class="detail-group-title">
            <div class="panel-title">Merchant Information Update</div>
            <button class="close-icon" (click)="onClose()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }

        @if (detail?.changedFields?.length) {
          @for (field of detail.changedFields; track field) {
            <div class="detail-row">
              <div class="field-label">{{ getChangedFieldLabel(field) }}</div>
              <div class="field-value">
                @if (detail.newValues[field] !== undefined) {
                  <span class="new-value">
                    <b>{{ detail.newValues[field] }}</b>
                  </span>
                }
                @if (detail.oldValues[field] !== undefined) {
                  <span class="old-value">
                    {{ detail.oldValues[field] }}
                  </span>
                }
              </div>
            </div>
          }
        }

        <div class="detail-row">
          <div class="field-label">Prepared by</div>
          <div class="field-value">{{ initiatedBy || 'N/A' }}</div>
        </div>

        @if (resolvedBy) {
          <div class="detail-row">
            <div class="field-label">Resolved by</div>
            <div class="field-value">{{ resolvedBy }}</div>
          </div>
        }

        <div class="detail-row">
          <div class="field-label">Request Date</div>
          <div class="field-value">{{ formatDateStandard(preparedDate) }}</div>
        </div>

        @if (resolvedAt) {
          <div class="detail-row">
            <div class="field-label">Resolution Date</div>
            <div class="field-value">{{ formatDateStandard(resolvedAt) }}</div>
          </div>
        }

        @if (resolution) {
          <div class="detail-row">
            <div class="field-label">Resolution</div>
            <app-state-badge [status]="resolution"></app-state-badge>
          </div>
        }

        <div class="detail-row">
          <div class="field-label">Status</div>
          <app-state-badge [status]="status"></app-state-badge>
        </div>
        @if (isHistory) {
          <ng-container *ngTemplateOutlet="commentBlock"></ng-container>
        }
      </div>
    </div>

    @if (!isHistory && canResolve) {
      <div class="sidebar-actions">
        @if (errorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ errorMessage }}
          </div>
        }
        <ng-container *ngTemplateOutlet="commentBlock"></ng-container>
        <div class="button-group" *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Acknowledge }">
          <app-button
            buttonVariant="primary"
            buttonType="button"
            [state]="acknowledgeButtonState"
            (buttonClick)="resolveTask(TaskResolutionEnum.Approved)"
          >
            {{ isProcessing ? 'Processing...' : 'Acknowledge' }}
          </app-button>
        </div>
      </div>
    }
  </div>
</div>
<ng-template #commentBlock>
  <div class="comments-heading">Comments</div>
  <textarea
    class="comment-box"
    aria-label="Comments"
    [(ngModel)]="comment"
    [placeholder]="isHistory ? 'No comment' : 'Enter your comment'"
    [disabled]="isHistory || isProcessing"
  ></textarea>
</ng-template>
